var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.questions),function(q){return _c('CounselingQuestion',{key:q.id,attrs:{"question":q,"value":_vm.getQuestionAnswer(q.id)},on:{"input":function($event){return _vm.setQuestionAnswer(q.id, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }